import React from 'react';
import { Outlet } from 'react-router-dom';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
export function Layout() {
  return <div className="flex flex-col min-h-screen" data-id="element-112">
      <Navbar data-id="element-113" />
      <main className="flex-grow" data-id="element-114">
        <Outlet data-id="element-115" />
      </main>
      <Footer data-id="element-116" />
    </div>;
}